import SunCalc from 'suncalc';
import {lightProfiles} from '../../lightProfiles';

function buildConfiguration(id, lat, long, tz) {
	let configuration = null;
	const namedDays = calculateDays(lat, long);
	let p = lightProfiles.find(profile => profile.id === id);
	p = JSON.parse(JSON.stringify(p));
	p = resolveNamedDays(p, namedDays);
	// p = mirrorDatesForSouthernHemisphere(p, lat, long);
	if (p && p.configuration) {
		configuration = p.configuration;
		configuration.latitude = lat;
		configuration.longitude = long;
		configuration.simulation_start = '2024-01-01T11:00:00Z';
		configuration.simulation_end = '2025-01-01T11:00:00Z';
		configuration.localtimezone = tz;
	}
	return configuration;
}

function resolveNamedDays(obj, namedDays) {
	Object.keys(obj).forEach(key => {
		const value = obj[key];
		if ( (key === 'from' || key === 'to') && value.hasOwnProperty('namedDate')) {
			const date = new Date(namedDays[value.namedDate]);
			if (value.hasOwnProperty('offset')) {
				date.setDate(date.getDate() + value.offset);
			}
			value.day = date.getDate();
			value.month = date.getMonth() + 1;
			//delete value.namedDate;
			//delete value.offset;
		} else if (typeof value === 'object') {
			resolveNamedDays(value, namedDays);
		}
	});
	return obj;
}

// update origDate to respective dates on southern hemisphere
function mirrorDatesForSouthernHemisphere(obj, lat, long) {
	if (lat > 0) return obj; // northern hemisphere
	Object.keys(obj).forEach(key => {
		const value = obj[key];
		if ( (key === 'from' || key === 'to')) {
			const date = new Date(Date.UTC(2024, value.month, value.day, 0, 0, 0));
			date.setDate(date.getDate() + 365/2);
			value.day = date.getDate();
			value.month = date.getMonth() + 1;
		} else if (typeof value === 'object') {
			mirrorDatesForSouthernHemisphere(value, lat, long);
		}
	});
	return obj;
}

function calculateDays(latitude, longitude) {
	const winterDayLength = 10.5;
	let winterStart = null;
	let winterEnd = null;
	for (let d = 1; d <= 365; d++) {
		const dayDate = new Date(2024, 0, d, 12, 0, 0);
		const prevDayDate = new Date(2024, 0, d - 1, 12, 0, 0);

		const suntime = SunCalc.getTimes(dayDate, latitude, longitude);
		const sunhours = (suntime.sunset.getTime() - suntime.sunrise.getTime()) / (1000 * 60 * 60);

		const prevSuntime = SunCalc.getTimes(prevDayDate, latitude, longitude);
		const prevSunhours = (prevSuntime.sunset.getTime() - prevSuntime.sunrise.getTime()) / (1000 * 60 * 60);

		// winter ends when days get longer then 10h30m
		if (prevSunhours < winterDayLength && sunhours >= winterDayLength) {
			winterEnd = dayDate;
		}
		// winter starts when days get shorter then 10h30m
		if (prevSunhours >= winterDayLength && sunhours < winterDayLength) {
			winterStart = dayDate;
		}
	}
	const namedDays = {
		winterstart: winterStart,
		winterend: winterEnd
	};
	return namedDays;
}

export default buildConfiguration;
